import AcquisitionController from './acquisition.controller';

/*@ngInject*/
export default function usersRoutes($stateProvider) {

    $stateProvider
        .state('acquisition', {
            url: '/acquisition',
            templateUrl: require('./acquisition.tpl.ftl'),
            controller: AcquisitionController,
            controllerAs: 'ctrl',
            resolve: {}
        });
}
